import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class ManageLicensesService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  managelicenses(manageLicensesUrl, data, companyId) {
    manageLicensesUrl = this.httpClientService.replaceTextInUrl('{companyid}', companyId, manageLicensesUrl);
    return this.httpClientService.authorizedPut(manageLicensesUrl, data)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }

  createPageLoadProperties(url: string, manageTitle: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_USERS;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    if (ENV_PORTAL === 'fnabc') {
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
      }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  setUpdateProduct(url, data) {
    let headers = new HttpHeaders();
    headers = headers.append('PermType', 'inventory.productDescription');
    const descObj = {};
    descObj['name'] = data.productDesc;
    const newUrl = url + data.clientId;
    return this.httpClientService.authorizedPatch(newUrl, descObj, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
      }
      ),catchError( this.handleError ));
  }

}
